import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { toast } from 'react-toastify';

const MypageCheckupComplete = () => {
  const [ status, setStatus ] = useState<string | null>(null);
  const [ sessionId, setSessionId ] = useState<string | null>(null);
  const { post } = useApi();
  const postedRef = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search.slice(1));

    setStatus(params.get('status'));
    setSessionId(params.get('session_id'));
  }, [])

  useEffect(() => {
    if (status && sessionId && !postedRef.current) {
      postedRef.current = true;
      post({
        endpoint: '/api/v1/complete_checkout_session',
        body: { status, session_id: sessionId },
        onError: () => {
          toast.error('決済情報の更新に失敗しました。時間をおいて再度お試しください。');
        },
      });
    }
  }, [status, sessionId, post]);

  return (
    <main className="sub">
      <section className="donor_pay">
        { status === 'succeeded' ?
          <>
            <h2 className="main_title">
              <span>お支払い・仮登録が完了いたしました</span>
            </h2>
            <h3 className="sub_title">お支払いいただきありがとうございます。</h3>
            <p>
              支払いが完了いたしましたので、これから検査結果の審査を行います。弊社内での審査完了をもって、正式に登録完了となります。<br />
              審査には最大で3営業日お時間がかかりますので、完了まで今しばらくお待ちくださいませ。
            </p>
          </>:
          <>
            <h2 className="main_title">
              <span>お支払いは<strong className='text-red'>完了していません</strong></span>
            </h2>
            <p>
              支払いが失敗もしくはキャンセルされました。検査結果登録画面より再度お支払いをお願いいたします。<br/>
              意図せずこの画面が複数回表示されている場合は、時間をおいてから再度お試しください。
            </p>
          </>
        }
        <Link to="/mypage/checkups" className="w_bluebtn">検査結果登録トップへ</Link>
      </section>
    </main>
  );
}

export default MypageCheckupComplete;